import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'properFilter'
})
export class ProperFilterPipe implements PipeTransform {
 
  transform(entities: any[], searchProofed: boolean): any[] {
   
    var results = this.filterByProofed(entities, searchProofed);

    return results; 
 
   }
    
   private filterByProofed(entities: any[], searchProofed: boolean) {
     
    if (searchProofed === true) {
      var results = entities.filter((entity) => {
         return (entity.IsProofed === true);
      });
      
      return results;
    } 
    else if (searchProofed == false) {
      var results = entities.filter((entity) => {
         return (entity.IsProofed === false);
      });

      return results;
    } 
    else {
      return entities;
    }

 }
}
